import { render, staticRenderFns } from "./RegionCenter.vue?vue&type=template&id=351ea0dc&scoped=true&"
import script from "./RegionCenter.vue?vue&type=script&lang=js&"
export * from "./RegionCenter.vue?vue&type=script&lang=js&"
import style0 from "./RegionCenter.vue?vue&type=style&index=0&id=351ea0dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ea0dc",
  null
  
)

export default component.exports